import WordPressApiClient from './client'
import Options from './ressources/Options'
import Pages from './ressources/Pages'
import Trips from './ressources/Trips'
import WPForms from './ressources/WPForms'

const baseUri = 'https://www.domaine-madame-elisabeth.fr'
const baseRoute = 'wp-json'

const ACF_CLIENT = new WordPressApiClient({
  baseUri,
  version: 'v2',
  baseRoute,
  from: 'acf'
})

const WP_CLIENT = new WordPressApiClient({
  baseUri,
  version: 'v2',
  baseRoute,
  from: 'wp'
})

const WPFORMS_CLIENT = new WordPressApiClient({
  baseUri,
  version: 'v1',
  baseRoute,
  from: 'wpforms'
})

export default {
  options: new Options(ACF_CLIENT),
  pages: new Pages(WP_CLIENT),
  trips: new Trips(WP_CLIENT),
  wpforms: new WPForms(WPFORMS_CLIENT),
}


// WEBPACK FOOTER //
// ./src/services/wpapi/index.js